import React from 'react';
import Lightbox from 'react-images';
import breadImages from '../data/breadImages';
import { I18nContext } from '../i18n/I18nContext';
import styles from '../styles/gallery.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const createPhoto = (src, title, category, width = 1200, height = 900) => ({
  src,
  title,
  category,
  alt: title,
  width,
  height,
  sizes: [
    '(min-width: 480px) 50vw',
    '(min-width: 1024px) 33.3vw',
    '100vw',
  ],
});

const existingPhotos = [
  createPhoto(`${publicUrl}/images/picture1.webp`, 'Fresh sandwich', 'food'),
  createPhoto(`${publicUrl}/images/brand/coffee.webp`, 'Fresh coffee', 'food'),
  createPhoto(`${publicUrl}/images/bloody.webp`, 'Signature cocktail', 'food'),
];

const breadPhotos = breadImages.map(image => (
  createPhoto(
    `${publicUrl}/images/${image.file}`,
    image.title,
    image.categoryKey === 'kozunak' ? 'kozunak' : 'bread',
  )
));

const photoSet = [...existingPhotos, ...breadPhotos];
const categoryTabs = [
  { id: 'bread', translationKey: 'gallery.breads' },
  { id: 'food', translationKey: 'gallery.foodDrinks' },
  { id: 'kozunak', translationKey: 'gallery.kozunak' },
];

export default class Galerie extends React.PureComponent {
  static contextType = I18nContext;

  constructor() {
    super();
    this.state = { currentImage: 0, lightboxIsOpen: false, activeCategory: 'bread' };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
  }

  getVisiblePhotos() {
    return photoSet.filter(photo => photo.category === this.state.activeCategory);
  }

  selectCategory(activeCategory) {
    this.setState({ activeCategory, currentImage: 0, lightboxIsOpen: false });
  }

  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious() {
    this.setState({
      currentImage: Math.max(this.state.currentImage - 1, 0),
    });
  }

  gotoNext() {
    const visiblePhotos = this.getVisiblePhotos();
    this.setState({
      currentImage: Math.min(this.state.currentImage + 1, visiblePhotos.length - 1),
    });
  }

  render() {
    const { t } = this.context;
    const visiblePhotos = this.getVisiblePhotos();

    return (
      <main className={styles.page}>
        <header
          className={styles.hero}
          style={{ backgroundImage: `url(${publicUrl}/images/hero/Galeria.webp)` }}
        >
          <h1>Galerie</h1>
        </header>

        <section className={styles.gallery} aria-label="Grain Bites gallery">
          <nav className={styles.tabs} aria-label="Gallery categories">
            {categoryTabs.map(tab => (
              <button
                className={`${styles.tab} ${this.state.activeCategory === tab.id ? styles.activeTab : ''}`}
                key={tab.id}
                type="button"
                aria-pressed={this.state.activeCategory === tab.id}
                onClick={() => this.selectCategory(tab.id)}
              >
                {t(tab.translationKey)}
              </button>
            ))}
          </nav>
          <div className={styles.grid}>
            {visiblePhotos.map((photo, index) => (
              <button
                className={styles.card}
                key={`${photo.src}-${index}`}
                type="button"
                aria-label={`Open ${photo.title}`}
                onClick={event => this.openLightbox(event, { index })}
              >
                <img src={photo.src} alt={photo.alt} loading="lazy" />
                <span className={styles.overlay} aria-hidden="true">
                  <span>{photo.title}</span>
                </span>
              </button>
            ))}
          </div>
        </section>
        <Lightbox
          theme={{ container: { background: 'rgba(0, 0, 0, 0.85)' } }}
          images={visiblePhotos.map(image => ({ ...image, srcset: image.srcSet, caption: image.title }))}
          backdropClosesModal
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
          width={1600}
        />
      </main>
    );
  }
}
